<template>
    <WidgetTitle
        :styles="content.styles"
        :translation="content.translation"
        :upload="content.upload"
    >
        <div class="d-flex flex-wrap align-items-stretch mt-4">
            <div
                class="px-3 col-lg-4 col-md-6 col-sm-6 col-12 my-2"
                v-for="content in contents"
                :key="content.id"
            >
                <HomePost :value="content.post"/>
            </div>
        </div>
    </WidgetTitle>
</template>

<script>
import HomePost from '@blog/components/HomePost'
import WidgetTitle from '../Common/WidgetTitle'

export default {
    name: 'HomePosts',
    props: {
        content: {
            type: Object,
            require: true
        },
    },
    components: {
        WidgetTitle,
        HomePost,
    },
    data() {
        return {
            contents: this.content.contents
        }
    },
    computed: {
        color() {
            return this.$store.getters.COLOR
        },
    },
}
</script>
